import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/admin-login",
    name: "admin_login",
    component: () => import("../views/AdminLogin.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("../views/Admin.vue"),
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("../components/admin/Dashboard.vue"),
      },
      {
        path: "dip",
        name: "dip",
        component: () => import("../components/admin/TableDIP.vue"),
      },
      {
        path: "news",
        name: "news",
        component: () => import("../components/admin/TableNews.vue"),
      },
      {
        path: "new_news_:id",
        name: "new_news",
        component: () => import("../components/admin/NewNews.vue"),
      },
      {
        path: "detail_news_:id",
        name: "detail_news",
        component: () => import("../components/admin/DetailNews.vue"),
      },
      {
        path: "newdip",
        name: "NewDIP",
        component: () => import("../components/admin/NewDIP.vue"),
      },
      {
        path: "newnews",
        name: "NewNews",
        component: () => import("../components/admin/NewNews.vue"),
      },
      {
        path: "detail_dip_:id",
        name: "DetailDIP",
        component: () => import("../components/admin/DetailDIP.vue"),
      },
      {
        path: "editdip/:id",
        name: "EditDIP",
        component: () => import("../components/admin/NewDIP.vue"),
      },

      {
        path: "nodin",
        name: "nodin",
        component: () => import("../components/admin/NotaDinas.vue"),
      },
      { 
        path: "jawabannodin", 
        name: "jawabannodin",
        component: () => import("../components/admin/JawabanNotaDinas.vue"),
      },
      {
        path: "sop",
        name: "sop",
        component: () => import("../components/admin/TableSOP.vue"),
      },
      {
        path: "detail_sop_:id",
        name: "detail_sop",
        component: () => import("../components/admin/DetailSOP.vue"),
      },
      {
        path: "new_sop_:id",
        name: "new_sop",
        component: () => import("../components/admin/NewSOP.vue"),
      },
      {
        path: "regulasi",
        name: "regulasi",
        component: () => import("../components/admin/TableRegulasi.vue"),
      },
      {
        path: "detail_regulasi_:id",
        name: "detail_regulasi",
        component: () => import("../components/admin/DetailRegulasi.vue"),
      },
      {
        path: "new_regulasi_:id",
        name: "new_regulasi",
        component: () => import("../components/admin/NewRegulasi.vue"),
      },
      {
        path: "pejabat",
        name: "pejabat",
        component: () => import("../components/admin/TablePejabat.vue"),
      },
      {
        path: "detail_pejabat_:id",
        name: "detail_pejabat",
        component: () => import("../components/admin/DetailPejabat.vue"),
      },
      {
        path: "new_pejabat_:id",
        name: "new_pejabat",
        component: () => import("../components/admin/NewPejabat.vue"),
      },
      {
        path: "laporan",
        name: "laporan",
        component: () => import("../components/admin/TableLaporan.vue"),
      },
      {
        path: "detail_laporan_:id",
        name: "detail_laporan",
        component: () => import("../components/admin/DetailLaporan.vue"),
      },
      {
        path: "new_laporan_:id",
        name: "new_laporan",
        component: () => import("../components/admin/NewLaporan.vue"),
      },
      {
        path: "agenda",
        name: "agenda",
        component: () => import("../components/admin/TableAgenda.vue"),
      },
      {
        path: "detail_agenda_:id",
        name: "detail_agenda",
        component: () => import("../components/admin/DetailAgenda.vue"),
      },
      {
        path: "new_agenda_:id",
        name: "new_agenda",
        component: () => import("../components/admin/NewAgenda.vue"),
      },


      { path: "setting", name: "setting"},

      {
        path: "unit_kerja",
        name: "unit_kerja",
        component: () => import("../components/setting/TableUnitKerja.vue"),
      },
      {
        path: "new_unit_kerja_:id",
        name: "new_unit_kerja",
        component: () => import("../components/setting/NewUnitKerja.vue"),
      },
      {
        path: "detail_unit_kerja_:id",
        name: "detail_unit_kerja",
        component: () => import("../components/setting/DetailUnitKerja.vue"),
      },

      {
        path: "jabatan",
        name: "jabatan",
        component: () => import("../components/setting/TableJabatan.vue"),
      },
      {
        path: "new_jabatan_:id",
        name: "new_jabatan",
        component: () => import("../components/setting/NewJabatan.vue"),
      },
      {
        path: "detail_jabatan_:id",
        name: "detail_jabatan",
        component: () => import("../components/setting/DetailJabatan.vue"),
      },

      {
        path: "kategori_informasi",
        name: "kategori_informasi",
        component: () =>
          import("../components/setting/TableKategoriInformasi.vue"),
      },
      {
        path: "new_kategori_informasi_:id",
        name: "new_kategori_informasi",
        component: () =>
          import("../components/setting/NewKategoriInformasi.vue"),
      },
      {
        path: "detail_kategori_informasi_:id",
        name: "detail_kategori_informasi",
        component: () =>
          import("../components/setting/DetailKategoriInformasi.vue"),
      },

      {
        path: "bentuk_informasi",
        name: "bentuk_informasi",
        component: () =>
          import("../components/setting/TableBentukInformasi.vue"),
      },
      {
        path: "new_bentuk_informasi_:id",
        name: "new_bentuk_informasi",
        component: () => import("../components/setting/NewBentukInformasi.vue"),
      },
      {
        path: "detail_bentuk_informasi_:id",
        name: "detail_bentuk_informasi",
        component: () =>
          import("../components/setting/DetailBentukInformasi.vue"),
      },

      {
        path: "user_admin",
        name: "user_admin",
        component: () => import("../components/setting/TableUserAdmin.vue"),
      },
      {
        path: "new_user_admin_:id",
        name: "new_user_admin",
        component: () => import("../components/setting/NewUserAdmin.vue"),
      },
      {
        path: "detail_user_admin_:id",
        name: "detail_user_admin",
        component: () => import("../components/setting/DetailUserAdmin.vue"),
      },

      {
        path: "user_pemohon",
        name: "user_pemohon",
        component: () => import("../components/setting/TableUserPemohon.vue"),
      },
      {
        path: "detail_user_pemohon_:id",
        name: "detail_user_pemohon",
        component: () => import("../components/setting/DetailUserPemohon.vue"),
      },

      {
        path: "alasan_penolakan",
        name: "alasan_penolakan",
        component: () =>
          import("../components/setting/TableAlasanPenolakan.vue"),
      },
      {
        path: "new_alasan_penolakan_:id",
        name: "new_alasan_penolakan",
        component: () => import("../components/setting/NewAlasanPenolakan.vue"),
      },
      {
        path: "detail_alasan_penolakan_:id",
        name: "detail_alasan_penolakan",
        component: () =>
          import("../components/setting/DetailAlasanPenolakan.vue"),
      },

      {
        path: "peran_pengguna",
        name: "peran_pengguna",
        component: () => import("../components/setting/TablePeranPengguna.vue"),
      },
      {
        path: "new_peran_pengguna_:id",
        name: "new_peran_pengguna",
        component: () => import("../components/setting/NewPeranPengguna.vue"),
      },
      {
        path: "detail_peran_pengguna_:id",
        name: "detail_peran_pengguna",
        component: () =>
          import("../components/setting/DetailPeranPengguna.vue"),
      },
      ///Update Form Permohonan dan Keberatan
      {
        path: "permohonan",
        name: "permohonan",
        component: () => import("../components/admin/TablePermohonan.vue"),
      },
      {
        path: "keberatan",
        name: "keberatan",
        component: () => import("../components/admin/TableKeberatan.vue"),
      },
      {
        path: "detail_permohonan_info_:id",
        name: "detail_permohonan_info_:id",
        component: () => import("../components/admin/DetailPermohonanInfo.vue"),
      },
      {
        path: "detail_keberatan_info_:id",
        name: "detail_keberatan_info_:id",
        component: () => import("../components/admin/DetailKeberatanInfo.vue"),
      },
      {
        path: "banner",
        name: "banner",
        component: () => import("../components/admin/Banner.vue"),
      },

    ],
  },
  //mungkin dihapus
  {
    path: "/info/:info_id",
    name: "InfoDetail",
    component: () => import("../components/PublicInfoDetail.vue"),
  },
  //end mungkindihapus
  {
    path: "/profil",
    name: "Profil",
    component: () => import("../views/Profile.vue"),
  },
  {
    path: "/profil-pejabat/:id",
    name: "ProfilPejabat",
    component: () => import("../components/OfficialDetail.vue"),
  },
  {
    path: "/regulasi",
    name: "PageRegulasi",
    component: () => import("../views/Regulation.vue"),
  },
  {
    path: "/laporan",
    name: "PageLaporan",
    component: () => import("../views/Report.vue"),
  },
  {
    path: "/sop",
    name: "PageSOP",
    component: () => import("../views/SOP.vue"),
  },
  {
    path: "/berita",
    component: () => import("../views/News.vue"),
    children: [
      {
        path: "",
        name: "PageBerita",
        component: () => import("../components/NewsPage.vue"),
      },
      {
        path: "list",
        name: "List",
        component: () => import("../components/NewsPage.vue"),
      },
      {
        path: "detail/:news_id",
        name: "Detail",
        component: () => import("../components/NewsDetail.vue"),
      },
    ],
  },

  // {
  //   path: '/user-login', name: 'UserLogin', component: () => import('../views/UserLogin.vue')
  // },

  {
    path: "/user",
    name: "User",
    component: () => import("../views/User.vue"),
    children: [
      {
        path: "login",
        name: "login",
        component: () => import("../components/UserLogin.vue"),
      },
      {
        path: "register",
        name: "register",
        component: () => import("../components/UserRegister.vue"),
      },
      {
        path: "forget/:tkn",
        name: "forget",
        component: () => import("../components/UserForgetPassword.vue"),
      },
    ],
  },
  {
    path: "/prosedur-permohonan",
    name: "ProsedurPermohonan",
    component: () => import("../views/ProsedurPermohonan.vue"),
  },
  {
    path: "/prosedur-keberatan",
    name: "ProsedurKeberatan",
    component: () => import("../views/ProsedurKeberatan.vue"),
  },
  {
    path: "/form-permohonan",
    name: "FormPermohonan",
    component: () => import("../views/FormPermohonan.vue"),
  },
  {
    path: "/form-keberatan",
    name: "FormKeberatan",
    component: () => import("../views/FormKeberatan.vue"),
  },
  {
    path: "/informasipublik/kategori/:id",
    name: "InformasiPublik",
    component: () => import("../views/InformasiPublik.vue"),
  },
  {
    path: "/daftar-permohonan-user",
    name: "DaftarPermohonanUser",
    component: () => import("../views/DaftarPermohonanUser.vue"),
  }
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    var paths = ["CategoryInfo"] //path name for exception
    // return desired position
    if(!paths.includes(to.name))
    {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
